import { render, staticRenderFns } from "./AttendeeListItem.vue?vue&type=template&id=2d506f0e&scoped=true&"
import script from "./AttendeeListItem.vue?vue&type=script&lang=js&"
export * from "./AttendeeListItem.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeListItem.vue?vue&type=style&index=0&id=2d506f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d506f0e",
  null
  
)

export default component.exports